import { generateCalendarDays } from '../utils/dateUtils';
import './StampCalendar.css';

interface StampCalendarProps {
  startDate: string;
  stamps: string[];
  onStamp?: (date: string) => void;
  isReadOnly?: boolean;
  compact?: boolean;
}

export default function StampCalendar({ 
  startDate, 
  stamps, 
  onStamp, 
  isReadOnly = false,
  compact = false 
}: StampCalendarProps) {
  const calendarDays = generateCalendarDays(startDate);
  
  const handleDayPress = (date: string) => {
    if (isReadOnly || !onStamp) return;

    // 日本時間での今日と昨日の日付のみクリック可能
    const now = new Date();
    const jstOffset = 9 * 60; // JST is UTC+9
    const jstNow = new Date(now.getTime() + jstOffset * 60 * 1000);

    const todayJST = new Date(jstNow.getFullYear(), jstNow.getMonth(), jstNow.getDate());
    const yesterdayJST = new Date(todayJST);
    yesterdayJST.setDate(yesterdayJST.getDate() - 1);

    const clickedDate = new Date(date.replace(/\./g, '-'));
    const isToday = clickedDate.toDateString() === todayJST.toDateString();
    const isYesterday = clickedDate.toDateString() === yesterdayJST.toDateString();

    if (!isToday && !isYesterday) return;

    onStamp(date.replaceAll('.', '-'));
  };

  const formatDateToMMDD = (dateString: string) => {
    // dateString は 'YYYY.MM.DD' 形式
    const parts = dateString.split('.');
    if (parts.length === 3) {
      const month = parts[1];
      const day = parts[2];
      return `${month}/${day}`;
    }
    return '';
  };
  const renderDay = (day: { date: string; hasStamp: boolean; isToday: boolean; isDisabled: boolean }, index: number) => {
    const hasStamp = stamps.includes(day.date.replaceAll('.', '-'));
    const isCurrentDay = day.isToday;
    const dayNumber = index + 1;
    const formattedDate = formatDateToMMDD(day.date);

    // 日本時間での今日と昨日の判定
    const now = new Date();
    const jstOffset = 9 * 60; // JST is UTC+9
    const jstNow = new Date(now.getTime() + jstOffset * 60 * 1000);

    const todayJST = new Date(jstNow.getFullYear(), jstNow.getMonth(), jstNow.getDate());
    const yesterdayJST = new Date(todayJST);
    yesterdayJST.setDate(yesterdayJST.getDate() - 1);

    const clickedDate = new Date(day.date.replace(/\./g, '-'));
    const isToday = clickedDate.toDateString() === todayJST.toDateString();
    const isYesterday = clickedDate.toDateString() === yesterdayJST.toDateString();
    const isClickable = isToday || isYesterday;

    return (
      <button
        key={day.date}
        className={`
          calendar-day
          ${compact ? 'calendar-day-compact' : ''}
          ${isCurrentDay ? 'calendar-day-today' : ''}
          ${day.isDisabled ? 'calendar-day-disabled' : ''}
          ${hasStamp ? 'calendar-day-stamped' : ''}
        `}
        onClick={() => handleDayPress(day.date)}
        disabled={isReadOnly || !isClickable}
      >
        <div className="day-content">
          <span className={`day-number ${compact ? 'day-number-compact' : ''}`}>
            {dayNumber}
          </span>
          <span className={`day-date ${compact ? 'day-date-compact' : ''}`}>
            {formattedDate}
          </span>
        </div>
      </button>
    );
  };

  const renderWeek = (weekDays: any[], weekIndex: number) => (
    <div key={weekIndex} className="calendar-week">
      {weekDays.map((day, dayIndex) => renderDay(day, weekIndex * 7 + dayIndex))}
    </div>
  );

  const weeks = [];
  for (let i = 0; i < calendarDays.length; i += 7) {
    weeks.push(calendarDays.slice(i, i + 7));
  }

  return (
    <div className="stamp-calendar">
      <div className="calendar-scroll">
        <div className="calendar-grid">
          {weeks.map((week, index) => renderWeek(week, index))}
        </div>
      </div>
    </div>
  );
}